import { helpers } from "../../../../packages/helpers";
import { ContextState } from "./types";

const { empty } = helpers.utilities;

export const defaultState: ContextState = {
  isFileLimitExceeded: false,
  exceedFileLimit: empty,
  resetFileLimitExceeded: empty,
};
